module.exports = __webpack_public_path__ + "img/O.578d899a.gif";